/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as UsersIndexImport } from './routes/users/index'
import { Route as StatanalyticsIndexImport } from './routes/statanalytics/index'
import { Route as RoomManagementIndexImport } from './routes/room-management/index'
import { Route as MttAnalyticsIndexImport } from './routes/mtt-analytics/index'
import { Route as InstanceIndexImport } from './routes/instance/index'
import { Route as HhErrorsJournalIndexImport } from './routes/hh-errors-journal/index'
import { Route as ErrorIndexImport } from './routes/error/index'
import { Route as AuthGroupsIndexImport } from './routes/auth-groups/index'
import { Route as UsersIdImport } from './routes/users/$id'
import { Route as ServiceConfigConfigNameImport } from './routes/service-config/$config-name'
import { Route as RoomManagementNameImport } from './routes/room-management/$name'
import { Route as AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameImport } from './routes/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name'
import { Route as RoomConfigRoomConfigNameImport } from './routes/room-config/$room.$config-name'
import { Route as AccountsRoomTypeImport } from './routes/accounts/$room.$type'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UsersIndexRoute = UsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRoute,
} as any)

const StatanalyticsIndexRoute = StatanalyticsIndexImport.update({
  id: '/statanalytics/',
  path: '/statanalytics/',
  getParentRoute: () => rootRoute,
} as any)

const RoomManagementIndexRoute = RoomManagementIndexImport.update({
  id: '/room-management/',
  path: '/room-management/',
  getParentRoute: () => rootRoute,
} as any)

const MttAnalyticsIndexRoute = MttAnalyticsIndexImport.update({
  id: '/mtt-analytics/',
  path: '/mtt-analytics/',
  getParentRoute: () => rootRoute,
} as any)

const InstanceIndexRoute = InstanceIndexImport.update({
  id: '/instance/',
  path: '/instance/',
  getParentRoute: () => rootRoute,
} as any)

const HhErrorsJournalIndexRoute = HhErrorsJournalIndexImport.update({
  id: '/hh-errors-journal/',
  path: '/hh-errors-journal/',
  getParentRoute: () => rootRoute,
} as any)

const ErrorIndexRoute = ErrorIndexImport.update({
  id: '/error/',
  path: '/error/',
  getParentRoute: () => rootRoute,
} as any)

const AuthGroupsIndexRoute = AuthGroupsIndexImport.update({
  id: '/auth-groups/',
  path: '/auth-groups/',
  getParentRoute: () => rootRoute,
} as any)

const UsersIdRoute = UsersIdImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRoute,
} as any)

const ServiceConfigConfigNameRoute = ServiceConfigConfigNameImport.update({
  id: '/service-config/$config-name',
  path: '/service-config/$config-name',
  getParentRoute: () => rootRoute,
} as any)

const RoomManagementNameRoute = RoomManagementNameImport.update({
  id: '/room-management/$name',
  path: '/room-management/$name',
  getParentRoute: () => rootRoute,
} as any)

const AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute =
  AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameImport.update({
    id: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name',
    path: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name',
    getParentRoute: () => rootRoute,
  } as any)

const RoomConfigRoomConfigNameRoute = RoomConfigRoomConfigNameImport.update({
  id: '/room-config/$room/$config-name',
  path: '/room-config/$room/$config-name',
  getParentRoute: () => rootRoute,
} as any)

const AccountsRoomTypeRoute = AccountsRoomTypeImport.update({
  id: '/accounts/$room/$type',
  path: '/accounts/$room/$type',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name': {
      id: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name'
      path: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name'
      fullPath: '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name'
      preLoaderRoute: typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameImport
      parentRoute: typeof rootRoute
    }
    '/room-management/$name': {
      id: '/room-management/$name'
      path: '/room-management/$name'
      fullPath: '/room-management/$name'
      preLoaderRoute: typeof RoomManagementNameImport
      parentRoute: typeof rootRoute
    }
    '/service-config/$config-name': {
      id: '/service-config/$config-name'
      path: '/service-config/$config-name'
      fullPath: '/service-config/$config-name'
      preLoaderRoute: typeof ServiceConfigConfigNameImport
      parentRoute: typeof rootRoute
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdImport
      parentRoute: typeof rootRoute
    }
    '/auth-groups/': {
      id: '/auth-groups/'
      path: '/auth-groups'
      fullPath: '/auth-groups'
      preLoaderRoute: typeof AuthGroupsIndexImport
      parentRoute: typeof rootRoute
    }
    '/error/': {
      id: '/error/'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorIndexImport
      parentRoute: typeof rootRoute
    }
    '/hh-errors-journal/': {
      id: '/hh-errors-journal/'
      path: '/hh-errors-journal'
      fullPath: '/hh-errors-journal'
      preLoaderRoute: typeof HhErrorsJournalIndexImport
      parentRoute: typeof rootRoute
    }
    '/instance/': {
      id: '/instance/'
      path: '/instance'
      fullPath: '/instance'
      preLoaderRoute: typeof InstanceIndexImport
      parentRoute: typeof rootRoute
    }
    '/mtt-analytics/': {
      id: '/mtt-analytics/'
      path: '/mtt-analytics'
      fullPath: '/mtt-analytics'
      preLoaderRoute: typeof MttAnalyticsIndexImport
      parentRoute: typeof rootRoute
    }
    '/room-management/': {
      id: '/room-management/'
      path: '/room-management'
      fullPath: '/room-management'
      preLoaderRoute: typeof RoomManagementIndexImport
      parentRoute: typeof rootRoute
    }
    '/statanalytics/': {
      id: '/statanalytics/'
      path: '/statanalytics'
      fullPath: '/statanalytics'
      preLoaderRoute: typeof StatanalyticsIndexImport
      parentRoute: typeof rootRoute
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexImport
      parentRoute: typeof rootRoute
    }
    '/accounts/$room/$type': {
      id: '/accounts/$room/$type'
      path: '/accounts/$room/$type'
      fullPath: '/accounts/$room/$type'
      preLoaderRoute: typeof AccountsRoomTypeImport
      parentRoute: typeof rootRoute
    }
    '/room-config/$room/$config-name': {
      id: '/room-config/$room/$config-name'
      path: '/room-config/$room/$config-name'
      fullPath: '/room-config/$room/$config-name'
      preLoaderRoute: typeof RoomConfigRoomConfigNameImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name': typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  '/room-management/$name': typeof RoomManagementNameRoute
  '/service-config/$config-name': typeof ServiceConfigConfigNameRoute
  '/users/$id': typeof UsersIdRoute
  '/auth-groups': typeof AuthGroupsIndexRoute
  '/error': typeof ErrorIndexRoute
  '/hh-errors-journal': typeof HhErrorsJournalIndexRoute
  '/instance': typeof InstanceIndexRoute
  '/mtt-analytics': typeof MttAnalyticsIndexRoute
  '/room-management': typeof RoomManagementIndexRoute
  '/statanalytics': typeof StatanalyticsIndexRoute
  '/users': typeof UsersIndexRoute
  '/accounts/$room/$type': typeof AccountsRoomTypeRoute
  '/room-config/$room/$config-name': typeof RoomConfigRoomConfigNameRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name': typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  '/room-management/$name': typeof RoomManagementNameRoute
  '/service-config/$config-name': typeof ServiceConfigConfigNameRoute
  '/users/$id': typeof UsersIdRoute
  '/auth-groups': typeof AuthGroupsIndexRoute
  '/error': typeof ErrorIndexRoute
  '/hh-errors-journal': typeof HhErrorsJournalIndexRoute
  '/instance': typeof InstanceIndexRoute
  '/mtt-analytics': typeof MttAnalyticsIndexRoute
  '/room-management': typeof RoomManagementIndexRoute
  '/statanalytics': typeof StatanalyticsIndexRoute
  '/users': typeof UsersIndexRoute
  '/accounts/$room/$type': typeof AccountsRoomTypeRoute
  '/room-config/$room/$config-name': typeof RoomConfigRoomConfigNameRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name': typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  '/room-management/$name': typeof RoomManagementNameRoute
  '/service-config/$config-name': typeof ServiceConfigConfigNameRoute
  '/users/$id': typeof UsersIdRoute
  '/auth-groups/': typeof AuthGroupsIndexRoute
  '/error/': typeof ErrorIndexRoute
  '/hh-errors-journal/': typeof HhErrorsJournalIndexRoute
  '/instance/': typeof InstanceIndexRoute
  '/mtt-analytics/': typeof MttAnalyticsIndexRoute
  '/room-management/': typeof RoomManagementIndexRoute
  '/statanalytics/': typeof StatanalyticsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/accounts/$room/$type': typeof AccountsRoomTypeRoute
  '/room-config/$room/$config-name': typeof RoomConfigRoomConfigNameRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name'
    | '/room-management/$name'
    | '/service-config/$config-name'
    | '/users/$id'
    | '/auth-groups'
    | '/error'
    | '/hh-errors-journal'
    | '/instance'
    | '/mtt-analytics'
    | '/room-management'
    | '/statanalytics'
    | '/users'
    | '/accounts/$room/$type'
    | '/room-config/$room/$config-name'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name'
    | '/room-management/$name'
    | '/service-config/$config-name'
    | '/users/$id'
    | '/auth-groups'
    | '/error'
    | '/hh-errors-journal'
    | '/instance'
    | '/mtt-analytics'
    | '/room-management'
    | '/statanalytics'
    | '/users'
    | '/accounts/$room/$type'
    | '/room-config/$room/$config-name'
  id:
    | '__root__'
    | '/'
    | '/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name'
    | '/room-management/$name'
    | '/service-config/$config-name'
    | '/users/$id'
    | '/auth-groups/'
    | '/error/'
    | '/hh-errors-journal/'
    | '/instance/'
    | '/mtt-analytics/'
    | '/room-management/'
    | '/statanalytics/'
    | '/users/'
    | '/accounts/$room/$type'
    | '/room-config/$room/$config-name'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute: typeof AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute
  RoomManagementNameRoute: typeof RoomManagementNameRoute
  ServiceConfigConfigNameRoute: typeof ServiceConfigConfigNameRoute
  UsersIdRoute: typeof UsersIdRoute
  AuthGroupsIndexRoute: typeof AuthGroupsIndexRoute
  ErrorIndexRoute: typeof ErrorIndexRoute
  HhErrorsJournalIndexRoute: typeof HhErrorsJournalIndexRoute
  InstanceIndexRoute: typeof InstanceIndexRoute
  MttAnalyticsIndexRoute: typeof MttAnalyticsIndexRoute
  RoomManagementIndexRoute: typeof RoomManagementIndexRoute
  StatanalyticsIndexRoute: typeof StatanalyticsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  AccountsRoomTypeRoute: typeof AccountsRoomTypeRoute
  RoomConfigRoomConfigNameRoute: typeof RoomConfigRoomConfigNameRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute:
    AiconConfigToremoveCauseItRemovedFromSeparateTabConfigNameRoute,
  RoomManagementNameRoute: RoomManagementNameRoute,
  ServiceConfigConfigNameRoute: ServiceConfigConfigNameRoute,
  UsersIdRoute: UsersIdRoute,
  AuthGroupsIndexRoute: AuthGroupsIndexRoute,
  ErrorIndexRoute: ErrorIndexRoute,
  HhErrorsJournalIndexRoute: HhErrorsJournalIndexRoute,
  InstanceIndexRoute: InstanceIndexRoute,
  MttAnalyticsIndexRoute: MttAnalyticsIndexRoute,
  RoomManagementIndexRoute: RoomManagementIndexRoute,
  StatanalyticsIndexRoute: StatanalyticsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  AccountsRoomTypeRoute: AccountsRoomTypeRoute,
  RoomConfigRoomConfigNameRoute: RoomConfigRoomConfigNameRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name",
        "/room-management/$name",
        "/service-config/$config-name",
        "/users/$id",
        "/auth-groups/",
        "/error/",
        "/hh-errors-journal/",
        "/instance/",
        "/mtt-analytics/",
        "/room-management/",
        "/statanalytics/",
        "/users/",
        "/accounts/$room/$type",
        "/room-config/$room/$config-name"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name": {
      "filePath": "aicon-config-toremove-cause-it-removed-from-separate-tab/$config-name.tsx"
    },
    "/room-management/$name": {
      "filePath": "room-management/$name.tsx"
    },
    "/service-config/$config-name": {
      "filePath": "service-config/$config-name.tsx"
    },
    "/users/$id": {
      "filePath": "users/$id.tsx"
    },
    "/auth-groups/": {
      "filePath": "auth-groups/index.tsx"
    },
    "/error/": {
      "filePath": "error/index.tsx"
    },
    "/hh-errors-journal/": {
      "filePath": "hh-errors-journal/index.tsx"
    },
    "/instance/": {
      "filePath": "instance/index.tsx"
    },
    "/mtt-analytics/": {
      "filePath": "mtt-analytics/index.tsx"
    },
    "/room-management/": {
      "filePath": "room-management/index.tsx"
    },
    "/statanalytics/": {
      "filePath": "statanalytics/index.tsx"
    },
    "/users/": {
      "filePath": "users/index.tsx"
    },
    "/accounts/$room/$type": {
      "filePath": "accounts/$room.$type.tsx"
    },
    "/room-config/$room/$config-name": {
      "filePath": "room-config/$room.$config-name.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
